@if ('lg' | up) {
  <div
    class="w-[calc(100%_+_288px)] h-[386px] rounded-[50%] bg-action-secondary translate-x-[-388px] translate-y-[-190px] blur-2xl fixed top-0 z-splash-bg pointer-events-none"
  ></div>
} @else {
  <div
    class="w-[calc(100%_+_600px)] h-[386px] rounded-[50%] bg-action-secondary translate-x-[-300px] translate-y-[-234px] blur-3xl fixed top-0 z-splash-bg pointer-events-none"
  ></div>
}

<div class="grow flex z-above-splash-bg">
  @if ('lg' | up) {
    <div class="flex flex-col">
      <div
        appScrollableSticky
        [containerStickyTopGap]="0"
        [containerStickyBottomGap]="0"
        [bottomOffsetElement]="footer"
        class="flex pt-2 px-2 pb-10 flex-col sticky self-start z-above-splash-bg"
      >
        @if (sideMenuVm(); as sideMenuVm) {
          <app-side-menu [vm]="sideMenuVm" (expandChange)="onSideMenuExpandChange($event)" />
        }
      </div>
    </div>
  }

  <div class="flex flex-col grow min-w-0 px-2 lg:pl-1 lg:pr-6 pb-10">
    <div
      class="grid grid-cols-[minmax(0,1fr)_auto] items-start lg:items-center gap-x-4 lg:gap-x-0 pt-2 lg:pt-4 pb-2 lg:px-4 z-above-splash-bg"
    >
      <app-breadcrumbs class="min-w-0" [vm]="breadcrumbsVm()" />
      <app-header-profile-section
        class="col-start-2 row-start-1 lg:row-span-2 lg:self-center"
        [vm]="headerProfileVm()"
        (quickNavigationClick)="onQuickNavigationClick()"
        (logoutClick)="onLogoutClick()"
        (exitImpersonationClick)="onExitImpersonationClick()"
      />
      @if (title$Signal() | async; as title) {
        <div class="col-span-2 lg:col-span-1 flex flex-col min-w-0 text-header-title text-[40px] font-medium">
          @if (customTitleTemplateSignal(); as customTitleTemplate) {
            <ng-container
              [ngTemplateOutlet]="customTitleTemplate.template"
              [ngTemplateOutletContext]="{
                $implicit: title,
                subtitle$: subtitle$Signal(),
                subtitleIsLoading: subtitleIsLoading(),
              }"
            ></ng-container>
          } @else {
            <span>{{ title }}</span>
          }
          @if (!customTitleTemplateSignal()?.includesSubtitle && subtitleIsLoading()) {
            <app-loading-skeleton class="-mt-1 h-4 w-[180px]" viewBox="0 0 180 16">
              <svg:rect x="0" y="0" rx="3" ry="3" width="180" height="16" />
            </app-loading-skeleton>
          } @else if (!customTitleTemplateSignal()?.includesSubtitle && (subtitle$Signal() | async); as subtitle) {
            <span class="-mt-2 text-sm font-normal opacity-90">{{ subtitle }}</span>
          }
        </div>
      } @else {
        <div class="col-span-2 lg:col-span-1 py-[10px]">
          <app-loading-skeleton class="w-[200px] h-[40px]" viewBox="0 0 200 40">
            <svg:rect x="0" y="0" rx="4" ry="4" width="200" height="40" />
          </app-loading-skeleton>
        </div>
      }
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
<div #footer [class.pb-12]="hasAiPermission() && hasAiAssistantEnabled()">
  <app-footer />
</div>
<app-ai-assistant-banner />
<app-ai-assistant-panel />
